import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';
import events from './events';
import PhotoSwipeThumbnails from './PhotoSwipeThumbnails';
import Photoswipe from './Photoswipe';

class PhotoSwipeGallery extends React.Component {
	handleClose() {
		this.props.onClose();
	}

	goToPhoto(itemIndex, e) {
		if (e) {
			e.preventDefault();
		}

		this.pswpComponent.photoSwipe.goTo(itemIndex);
	}

	render() {
		const {
			currentIndex,
			images,
			updateModalSettings,
			trackGa,
			modalSettings,
			viewportWidth,
			viewportHeight,
			widgetInfo,
			video,
			updateIsBeingDragged,
			...other
		} = this.props;

		const isDesktop = widgetInfo.deviceType === 'DESKTOP';
		const eventProps = {};
		for (let i = 0; i < events.length; i++) {
			if (other[events[i]]) {
				eventProps[events[i]] = other[events[i]];
			}
		}

		if (!modalSettings.modalIsOpen) {
			return null;
		} else {
			/* eslint-disable no-undef */
			const mobileOrientationIsPortrait =
				window?.DDC?.mobile?.orientation?.currentOrientation ===
				'portrait';
			/* eslint-enable */

			const currentModalIndex =
				modalSettings.persistIndex === false &&
				!Number.isNaN(modalSettings.currentIndex)
					? modalSettings.currentIndex
					: currentIndex;
			const showThumbnails =
				(mobileOrientationIsPortrait || isDesktop) &&
				!modalSettings.videoIsOpen &&
				!modalSettings.spin360IsOpen;
			const thumbnails = showThumbnails ? (
				<PhotoSwipeThumbnails
					images={images}
					currentIndex={currentModalIndex}
					goToPhoto={this.goToPhoto.bind(this)}
					viewportWidth={viewportWidth}
					isDesktop={isDesktop}
					trackGa={trackGa}
					updateIsBeingDragged={updateIsBeingDragged}
				/>
			) : null;

			return (
				<Common
					render={({ labels }) => {
						return (
							<div className="pswp-gallery-wrapper">
								<div className="pswp-gallery">
									<Photoswipe
										{...eventProps}
										isOpen
										items={images.map((image) => {
											if (image.html || image.callback) {
												const markup =
													image.html !== undefined
														? image.html
														: '';
												return {
													html: '<div style="position: absolute; top:0; width:100%; height:100%;" data-location-id="photoswipe"></div>',
													markup,
													callback: image.callback,
													resize: true,
													type: 'html'
												};
											}
											return {
												...image,
												h: 0,
												w: 0,
												resize: true,
												type: 'image'
											};
										})}
										ref={(pSwipeComp) => {
											this.pswpComponent = pSwipeComp;
										}}
										options={{
											index: currentModalIndex,
											modal: true,
											loop: true,
											history: false,
											closeElClasses: ['item'], // desktop: close when black background is clicked outside of image
											tapToClose: !isDesktop, // mobile: tap anywhere to close the modal gallery
											clickToCloseNonZoomable: false,
											barsSize: {
												top: 44,
												bottom: 150
											},
											closeOnScroll: false,
											closeOnVerticalDrag: false
										}}
										close={this.handleClose.bind(this)}
										updateModalSettings={
											updateModalSettings
										}
										trackGa={trackGa}
										video={video}
										modalSettings={modalSettings}
										widgetInfo={widgetInfo}
										viewportWidth={viewportWidth}
										viewportHeight={viewportHeight}
										mobileOrientationIsPortrait={
											mobileOrientationIsPortrait || false
										}
										labels={labels}
										updateIsBeingDragged={
											updateIsBeingDragged
										}
									/>
									{thumbnails}
								</div>
							</div>
						);
					}}
				/>
			);
		}
	}
}

PhotoSwipeGallery.propTypes = {
	currentIndex: PropTypes.number.isRequired,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string,
			thumbnail: PropTypes.string
		})
	).isRequired,
	onClose: PropTypes.func,
	updateModalSettings: PropTypes.func.isRequired,
	trackGa: PropTypes.func.isRequired,
	modalSettings: PropTypes.shape({
		zoomedIn: PropTypes.bool,
		fullScreen: PropTypes.bool,
		modalIsOpen: PropTypes.bool,
		persistIndex: PropTypes.bool,
		currentIndex: PropTypes.number,
		videoIsOpen: PropTypes.bool,
		spin360IsOpen: PropTypes.bool
	}).isRequired,
	widgetInfo: PropTypes.shape({
		deviceType: PropTypes.string,
		accountId: PropTypes.string
	}).isRequired,
	viewportWidth: PropTypes.number.isRequired,
	viewportHeight: PropTypes.number.isRequired,
	video: PropTypes.shape({}),
	updateIsBeingDragged: PropTypes.func
};

PhotoSwipeGallery.defaultProps = {
	onClose: () => {},
	video: null,
	updateIsBeingDragged: () => {}
};

export default PhotoSwipeGallery;
